import s from './../product.module.css';

const ProductTabDesription = () => {
    return (
        <div className={s.tabDescription}>
            <p>Постельное белье бязь-ранфорс Вилюта 17160. Очень красивая цветочная расцветка с веточками сакуры.
                Пастельные тона подходят под любой дизайн спальни.

                В нашем интернет-магазине "Статус-Текстиль" Вы можете выгодно купить постельное белье из бязи-ранфорс в
                Украине / Полтаве.

                Постельное белье торговой марки Вилюта с каждым днем становится все более популярным в Украине,
                потребитель ценит эту торговую марку за безукоризненное качество, красоту изделий, гибкую ценовую
                политику и лояльное отношение к покупателям
            </p>
            <p>Размеры постельного белья бязь-ранфорс:</p>
            <ul>
                <li>Полуторное</li>
                <li>Двуспальное</li>
                <li>Евро</li>
                <li>Семейный</li>
            </ul>
            <p>Постельное белье из бязи-ранфорс - качественное и недорогое постельное белье, которое Вы можете купить в
                нашем интернет-магазине по самой низкой цене в Украине / Полтаве!
            </p>
        </div>
    )
}

export default ProductTabDesription;